import { BffBrandType } from '@/gqlConstants';
import { NearbyFacility, BffFacility } from '@/graphql/__generated/sdk';
import { mapFacilities } from '@/utils/mapFacilitiesResults/mapFacilitiesResults';

import { brandThemeToFacilityBrand } from './brandThemeToFacilityBrand';
import { getBffNearByFacilitiesByLocation } from './getBffNearByFacilitiesByLocation';
import { getNearbyFacilities } from './getNearbyFacilities';
import { FacilitiesLoadingConfig } from './useFacilitiesSSR';

export async function getNearbyFacilitiesFromLocation({
	coords,
	config,
}: {
	coords: { latitude: number; longitude: number };
	config: FacilitiesLoadingConfig;
}) {
	let facilities: NearbyFacility[] = [];
	let nearbyFacilities: BffFacility[] | null = null;

	if (!coords.latitude && !coords.longitude) {
		return {
			facility: undefined,
			facilities: [],
			nearbyFacilities: null,
		};
	}
	if (config.useFacilityBeffeDataSource) {
		const res = await getBffNearByFacilitiesByLocation(
			brandThemeToFacilityBrand(config.brand).toString() as BffBrandType,
			coords.latitude || 0,
			coords.longitude || 0,
			config.bffGraphqlUrl,
			config.appName,
			config.appVersion
		);
		facilities = mapFacilities(res?.facilityByLocation);
		nearbyFacilities =
			res?.facilityByLocation?.filter((facility): facility is BffFacility => facility !== null) ?? null;
	} else {
		facilities = await getNearbyFacilities({
			appName: config.appName,
			appVersion: config.appVersion,
			enterpriseGraphqlUrl: config.enterpriseGraphqlUrl,
			brand: config.brand,
			coords: coords || { longitude: 0, latitude: 0 },
		});
	}
	const facility = facilities?.[0]?.facility ?? null;
	return {
		facility,
		facilities,
		nearbyFacilities,
	};
}
